/**
 * 首页/H5 页面共享配置
 */
export const WECHAT_LINK = 'https://mp.weixin.qq.com/'

export const STEPS_ITEMS = [
    { title: '需求沟通', description: '了解客户需求' },
    { title: '方案设计', description: '制定开发方案' },
    { title: '合同签订', description: '确认合作条款' },
    { title: '项目开发', description: '按计划实施' },
    { title: '测试验收', description: '质量保障' },
    { title: '交付上线', description: '项目交付' },
]
